export function handleKeystroke(code: string) {
  const element = document.activeElement as HTMLElement;

  if (code === 'Enter' || code === 'Space') {
    element?.click();
  }
}
